
    // this file was auto generated by python script
    import FastForward from './FastForward';
    export default FastForward;
    